<template>
    <div v-if="originLoginType === 'assur_cc'">
      <AssurCC
        :mechanicName="mechanicName"
        :mechanicGarage="mechanicGarage"
        :mechanicCode="mechanicCode"
      />
    </div>
    <div v-else-if="originLoginType === 'garanties_mechanics'">
      <GarantiesMechanic
        :mechanicName="mechanicName"
        :mechanicGarage="mechanicGarage"
        :mechanicCode="mechanicCode"
      />
    </div>
    <div v-else-if="originLoginType === 'dynassurances' && $can('read', 'account_representative')">
      <Dynassurances
        :mechanicName="mechanicName"
        :mechanicGarage="representativeName"
      />
    </div>
  <div v-else-if="originLoginType === 'dynassurances' && mechanicCode != '705223'">
      <Dynassurances
      :mechanicName="mechanicName"
      :mechanicGarage="mechanicGarage"
      :mechanicCode="mechanicCode"
      />
    </div>
    <div v-else>
      <div class="header">
        <div class="container-fluid">
          <div class="header__content">
            <div class="header__content__logo">
<!--              <a :href="dynassurancesUrl" class="logo__image">-->
<!--                <img src="../assets/logo.gif"-->
<!--                     alt="Dynassurances : L'assurance d'&ecirc;tre bien assur&eacute;"-->
<!--                     width="286" height="105"-->
<!--                     title="Dynassurances : L'assurance d'&ecirc;tre bien assur&eacute;"/>-->
<!--              </a>-->
            </div>
            <div class="header__greetings">{{greetings}}</div>
            <div class="header__content__account">
              <a href="" class="dropdown-toggle"
                 id="headerDropDown"
                 data-toggle="dropdown"
                 aria-haspopup="true"
                 aria-expanded="false">
                <div class="header__content__account__avatar">
                  <img src="../assets/avatar-default-white.png" alt="">
                </div>
                <div class="header__content__account__avatar--name">{{ mechanicName }}</div>
              </a>
              <div class="header__content__account__name">
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="headerDropDown">
                  <router-link class="dropdown-item" to="/my-account-representative" v-if="$can('read', 'account_representative') && !isMutuaideCommercial">
                    <span>Mon compte</span>
                  </router-link>
                  <router-link class="dropdown-item" to="/my-account" v-else-if="!$can('read', 'account_representative')">
                    <span>Mon compte</span>
                  </router-link>
                  <router-link class="dropdown-item" to="/my-documents" v-if="$can('read', 'account_representative') && !isMutuaideCommercial">
                    <span>Mes documents</span>
                  </router-link>
                  <a href="#" class="dropdown-item" @click="$root.logOut">
                    <span>Deconnexion</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>


<script>
    import AssurCC from "./Headers/AssurCC";
    import GarantiesMechanic from "./Headers/GarantiesMechanic";
    import Dynassurances from "./Headers/Dynassurances";
    const GLOBAL_URL = 'http://dynassurances.fr/';

    export default {
        name: 'Header',
      components: {Dynassurances, GarantiesMechanic, AssurCC},
      data() {
            return {
                home_page: GLOBAL_URL
            }
        },
        computed: {
            mechanicName() {
                let full_name = this.$store.state.userInfo.first_name;
                return full_name ? full_name : '';
            },
            mechanicGarage() {
              let garage = (this.$store.state.userInfo && this.$store.state.userInfo.mechanic) ? this.$store.state.userInfo.mechanic.garage : null;
              return garage ? garage : '';
            },
            mechanicCode() {
              let code = (this.$store.state.userInfo && this.$store.state.userInfo.mechanic) ? this.$store.state.userInfo.mechanic.code : null;
              return code ? code : '';
            },
            representativeName() {
              let name = (this.$store.state.userInfo && this.$store.state.userInfo.representative) ? this.$store.state.userInfo.representative.name : null;
              return name ? name : '';
            },
            greetings() {
                let code = this.$store.state.userInfo.mechanic && this.$store.state.userInfo.mechanic.code ? this.$store.state.userInfo.mechanic.code : '';
                let garage = this.$store.state.userInfo.mechanic && this.$store.state.userInfo.mechanic.garage ? this.$store.state.userInfo.mechanic.garage : '';
                return this.$store.state.userInfo.mechanic && garage && code ? `Bienvenue ${garage} - ${code}` : '';
            },
            originLoginType() {
              return this.$store.state.userInfo.origin_login || 'dynassurances';
            },
            dynassurancesUrl() {
                return this.$store.state.dynassurances_web_site_url
            },
            isMutuaideCommercial() {
              return this.$store.getters.isRepresentative && (this.$store.getters.getRepresentative.id == 15);
            }
        },
        methods: {},
        mounted() {

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Header.vue